import { useEffect } from 'react';

/**
 * 粘贴上传 Hook
 * @param doUpload 粘贴到文件时触发的上传函数
 */
export function usePasteUpload(doUpload: (file: File) => void, accept: string): void {
  useEffect(() => {
    function isAccepted(file: File): boolean {
      if (file.type.startsWith('image/') && accept.includes('image/*')) {
        return true;
      }
      if (file.type.startsWith('video/') && accept.includes('video/*')) {
        return true;
      }
      return false;
    }

    function handlePaste(event: ClipboardEvent): void {
      if (event.clipboardData == null) return;
      const items = Array.from(event.clipboardData.items);
      for (const item of items) {
        if (item.kind !== 'file') continue;
        const file = item.getAsFile();
        if (file == null || !isAccepted(file)) continue;
        doUpload(file);
      }
    }

    function handleDragOver(event: DragEvent): void {
      event.preventDefault();
    }

    function handleDrop(event: DragEvent): void {
      event.preventDefault();
      if (event.dataTransfer == null) return;
      const files = Array.from(event.dataTransfer.files);
      for (const file of files) {
        if (isAccepted(file)) {
          doUpload(file);
        }
      }
    }

    window.addEventListener('paste', handlePaste);
    window.addEventListener('dragover', handleDragOver);
    window.addEventListener('drop', handleDrop);
    return (): void => {
      window.removeEventListener('paste', handlePaste);
      window.removeEventListener('dragover', handleDragOver);
      window.removeEventListener('drop', handleDrop);
    };
  }, [doUpload, accept]);
}
